import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tx from '../Tx';
import { useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { api } from '../../maps/data.js';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { deviceTypeMap } from '../../maps/deviceTypeMap';

export default function AddEditEdgeDialog(props) {
    let { open, onClose } = props;

    const [deviceType, s_deviceType] = useState('JETSON_NX');

    const save = async () => {

        let apiCfg = {
            type: 'distributorCreateEdge',
            data: {
                deviceType
            }
        }

        await api(apiCfg);

        onClose();
    }

    return (
        <Dialog
            open={!!open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth={true}>
            <ValidatorForm
                onSubmit={save}
                onError={errors => console.log(errors)}>

                <DialogTitle id="alert-dialog-title">
                    <Tx>edge.add.title</Tx>
                </DialogTitle>
                <DialogContent style={{ paddingTop: 5 }}>

                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label"><Tx>edge.deviceType</Tx></FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="JETSON_NX"
                            name="radio-buttons-group"
                            value={deviceType}
                            onChange={e => s_deviceType(e.target.value)}>
                            {
                                deviceTypeMap.map((deviceType, idx) => <FormControlLabel key={idx} value={deviceType.value} control={<Radio />} label={<Tx>{deviceType.i18nKey}</Tx>} />)
                            }
                        </RadioGroup>
                    </FormControl>

                </DialogContent>

                <DialogActions>

                    <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
                    <Button autoFocus type='submit'>
                        <Tx>g.save</Tx>
                    </Button>

                </DialogActions>
            </ValidatorForm>
        </Dialog>)
}